// medplum-runtime.js — wires the WEB Medplum runtime into @healther/medplum-data
// (W5 stage 2). The package's data modules reach the client only through its
// client-port; this module registers the app's real implementation once, at
// import time. Every thin wrapper in this directory imports this module first,
// so any consumer of a data module gets the registration for free.
//
// The namespace-object form is deliberate: the port reads properties per call,
// so when a test vi.mock()s './medplum-client.js' the wrapper chain registers
// the MOCKED namespace and the data modules see the test's stubs — exactly the
// behavior the old direct imports had.
//
// W5 stage 8 (the write tier) added a SECOND source: the port's group-B host
// functions, which come from this app's own platform modules rather than from
// medplum-client.js. They are registered as a separate object rather than merged,
// so both sources keep the read-per-call property (a spread would snapshot the
// namespace and break vi.mock).
//
// WEB_HOST is registered FIRST (the port takes the first impl that HAS the
// function). The two sets are disjoint — medplum-client.js exports none of these
// five names — so the order changes no resolution; it exists because a vitest
// module mock THROWS on reading an export it does not define, and probing the
// plain object first means the mocked namespace is only ever asked for names it
// is actually expected to provide.
import { registerMedplumRuntime } from '@healther/medplum-data/client-port.js';
import * as client from './medplum-client.js';
import { getOutbox } from './outbox.js';
import { isNetworkError } from './net-error.js';
import { apiUrl } from './net-base.js';

// The BROWSER implementations of the port's platform functions. Each delegates
// at CALL time (never captures the import), so a test that mocks './outbox.js'
// or redefines navigator.onLine after import still steers them.
const WEB_HOST = {
  getOutbox: () => getOutbox(),
  // Byte-for-byte the check the write paths ran inline before the move: only an
  // EXPLICIT navigator.onLine === false means offline. A missing navigator (Node/
  // node:test) or an undefined onLine is treated as online — the authoritative
  // offline signal is a network throw from the call itself, not this hint.
  isOnline: () => !(typeof navigator !== 'undefined' && navigator.onLine === false),
  isNetworkError: (err) => isNetworkError(err),
  apiUrl: (path) => apiUrl(path),
};

registerMedplumRuntime(WEB_HOST, client);
